/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/news_events/media_statements/press_20240221.html'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/english/news_events/media_statements/press_20240221.html'
          );
        }}
        className="source2"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/tc_chi/news_events/media_statements/press_20240221.html'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.pcpd.org.hk/english/news_events/media_statements/press_20240221.html'
          );
        }}
        className="source2"
      />
    </div>
  </>
);

export default Components004;
